import React from "react";
import classnames from "classnames";
import { Button } from "components/UI";
import { bgApply } from "assets";
import { useNavigate } from "react-router-dom";
import { BackgroundSection } from ".";
import EmailSignUp from "./EmailSignUp";

const Apply = () => {
  const navigate = useNavigate();
  return (
    <>
      <BackgroundSection
        backgroundImage={`url(${bgApply.default})`}
        height="400px"
        className={classnames(
          "h-screen bg-no-repeat bg-cover xl:bg-full bg-center",
          "flex flex-col items-center text-center pt-20 justify-center content-center gap-3"
        )}
      >
        <h2 className="text-white">Join Our Gig Life Pro Community</h2>
        <p className="text-white">Together, we transform passion into success and shape the future of music.</p>
        <div>
          <Button
            label="SUBMIT YOUR APPLICATION"
            onClick={() => navigate("/signup")}
            className="py-4"
          />
        </div>
      </BackgroundSection>
      {/* <EmailSignUp /> */}
    </>
  );
};

export default Apply;
